import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MsgMngrService } from '../msg/msg-mngr.service';
import * as utils from '../common/utils';
import { aspMngr } from '../asp/AspMngr';
import { MatDialogConfig, DialogPosition } from '@angular/material/dialog';
import { SoundMsgMngrService } from '../msg/sound-msg-mngr.service';

export interface ConnectNotify {
  onConnect(): void;
}

export var connectNotifiers: ConnectNotify[] = new Array();

export function addConnectNotifier(notifier: ConnectNotify) {
  connectNotifiers.push(notifier);
}

@Component({
  selector: 'connect-dialog',
  templateUrl: './connect-dialog.component.html',
  styleUrls: ['../../global.scss']
})
export class ConnectDialogComponent implements OnInit {

  static readonly DIALOG_ID = 'connect';

  form: FormGroup;

  constructor(public dialogRef: MatDialogRef<ConnectDialogComponent>,
              private fb: FormBuilder,
              private msgMngr: MsgMngrService,
              public Sound: SoundMsgMngrService) {
  }

  static createDialogConfig(position) {
    return utils.createDialogConfig(false, true, ConnectDialogComponent.DIALOG_ID, position);
  }

  ngOnInit() {
    let serverField = '';
      serverField = `${this.msgMngr.hostname}`;
    this.form = this.fb.group({ serverField: [serverField, Validators.required],
      soundAddress: ["", Validators.required],
      soundToken: ["", Validators.required]
     });
  }

  onConnect() {
    aspMngr.deleteAllObjects();

    for (let notifier of connectNotifiers) {
      notifier.onConnect();
    }
    
    let host: string = this.form.value.serverField;
    if (host.length > 0) {
      this.msgMngr.setAddress(host);
      this.msgMngr.close();
      this.msgMngr.openWebSocket();
      this.dialogRef.close();
    }
  }

  onConnectSound() {
    console.log(this.form.value.soundAddress);
    this.Sound.setAdress(this.form.value.soundAddress);
    // send this to the connector service....
  }
}
